const faqs = [
    {
      question: "What services do you offer?",
      answer: "I specialize in building responsive websites, web apps, and portfolios using modern technologies like React.js, HTML, and CSS."
    },
    {
      question: "Do you work with clients remotely?",
      answer: "Yes, I work with clients from anywhere in the world. Communication is usually done via email, WhatsApp, or Zoom."
    },
    {
      question: "How long does it take to complete a project?",
      answer: "It depends on the scope. A basic portfolio takes 3–5 days, while a full web app might take a few weeks."
    },
    {
      question: "Do you offer maintenance after the project?",
      answer: "Yes, I provide post-project support and updates if needed."
    },
    {
      question: "Can you help with hosting and domain setup?",
      answer: "Absolutely. I can guide you through hosting on Vercel or Netlify and setting up your custom domain."
    }
  ];
  
  export default faqs;
  